var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-card',{staticStyle:{"color":"Red","margin-top":"100px !important"}},[_vm._v("\n\t\tUnder Construction\n\t")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }